module.exports = __webpack_public_path__ + "static/media/frontentrance.39b4adec.jpg";